@if (!sheetMode()) {
  <div class="floating-panel-drag-strip" cdkDragHandle aria-hidden="true">
    <span class="floating-panel-drag-grip"></span>
  </div>
}

@if (topbarLeftTemplate(); as tpl) {
  <div class="floating-panel-topbar-left">
    <ng-container [ngTemplateOutlet]="tpl"></ng-container>
  </div>
}

<div class="floating-panel-actions">
  @for (action of headerActions(); track $index) {
    <button
      eBtn
      size="sm"
      squared
      type="button"
      color="highlight"
      [icon]="action.icon ?? ''"
      iconColor="primary-75"
      [tooltip]="action.tooltip"
      [attr.aria-label]="action.tooltip"
      (click)="action.onClick(); $event.stopPropagation();"
    >@if (action.label) { {{ action.label }} }</button>
  }

  @if (panelRef(); as panel) {
    @if (panel.lockable) {
      @if (panel.lockedTo(); as lockedTo) {
        <button
          eBtn
          size="sm"
          type="button"
          color="highlight"
          icon="lock"
          iconColor="primary"
          class="floating-panel-lock-button is-locked"
          [tooltip]="unlockTooltip(lockedTo.label)"
          [attr.aria-label]="unlockTooltip(lockedTo.label)"
          (click)="panel.toggleLock(); $event.stopPropagation();"
        ><span class="floating-panel-lock-label">{{ lockedTo.label }}</span></button>
      } @else {
        @if (panel.lockCandidate(); as candidate) {
          <button
            eBtn
            size="sm"
            squared
            type="button"
            color="highlight"
            icon="lock-open"
            iconColor="primary-75"
            class="floating-panel-lock-button"
            [tooltip]="lockTooltip(candidate.label)"
            [attr.aria-label]="lockTooltip(candidate.label)"
            (click)="panel.toggleLock(); $event.stopPropagation();"
          ></button>
        }
      }
    }
  }

  @if (showDockButton()) {
    <button
      eBtn
      size="sm"
      squared
      type="button"
      color="highlight"
      icon="thumbtack"
      iconColor="primary-75"
      [tooltip]="tooltipDock"
      [attr.aria-label]="ariaLabelDock"
      (click)="dockRequested.emit(); $event.stopPropagation();"
    ></button>
  }

  @if (closable()) {
    <button
      eBtn
      size="sm"
      squared
      type="button"
      color="highlight"
      icon="xmark"
      iconColor="primary-75"
      [tooltip]="tooltipClose"
      [attr.aria-label]="ariaLabelClose"
      (click)="closeRequested.emit(); $event.stopPropagation();"
    ></button>
  }
</div>

<div #body class="floating-panel-body">
  <ng-container
    *ngComponentOutlet="componentType(); injector: outletInjector()"
  ></ng-container>
</div>
